module.exports = __webpack_public_path__ + "static/media/05.282133ec.mp3";